<div class="sections-wrapper">
  <ng-container *ngIf="dhwOneTimeCharge$ | async | ready as feature">
    <app-program-panel
      *ngIf="feature.properties?.active"
      program="oneTimeCharge"
      [active]="feature.properties?.active?.value"
    >
      <vi-icon icon name="heating-mode-comfort-white" [size]="20"></vi-icon>
      <ng-container message>{{
        '+SCHEDULES.PROGRAM_PANEL.ONE_TIME_CHARGE_MODE' | translate
      }}</ng-container>
    </app-program-panel>
  </ng-container>

  <div class="section-wrapper">
    <h3 class="section-heading">
      {{ '+INSTALLATIONS.INSTALLATION.WARM_WATER.TITLE_BASIC_SETTINGS' | translate }}
    </h3>
    <div class="section-row">
      <!-- 1. DHW Operating Mode -->
      <ng-container *ngIf="dhwActiveOperatingMode$ | async | ready as feature">
        <ng-container *ngIf="feature | executable: featureCommands.setMode">
          <mat-form-field class="select-dhw-operating-mode" mat-select-height-large>
            <mat-label
              matTooltip="{{
                '+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_SELECT_OPERATING_MODE' | translate
              }}"
              >{{
                '+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_SELECT_OPERATING_MODE' | translate
              }}</mat-label
            >
            <mat-select
              data-at-dhw-operating-mode-select
              fieldTextContentTooltip
              (selectionChange)="onDhwOperatingModeChanged($event)"
              name="{{
                '+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_SELECT_OPERATING_MODE' | translate
              }}"
              [value]="dhwActiveOperatingMode"
              [placeholder]="feature | value2: featurePropertyKey.value | translateDhwOperatingMode"
            >
              <mat-select-trigger>
                {{ dhwActiveOperatingMode | translateDhwOperatingMode }}
                <mat-icon
                  *ngIf="
                    (dhwEcoModeLeading$ | async | ready) &&
                    (dhwTemperatureComfortCharging$ | async | ready)
                  "
                  matPrefix
                  class="info-icon"
                  [matTooltip]="
                    '+INSTALLATIONS.INSTALLATION.WARM_WATER.OPERATING_MODE_WITH_LEADING_AND_COMFORT_CHARGING'
                      | translate
                  "
                  matTooltipPosition="above"
                >
                  info_outline
                </mat-icon>
              </mat-select-trigger>
              <mat-option
                gtm="onSelect"
                gtmAction="DHW Operating Mode"
                gtmCategory="dhw"
                fieldTextContentTooltip
                *ngFor="let mode of feature.commands?.setMode?.params?.mode?.constraints?.enum"
                [value]="mode"
              >
                {{ mode | translateDhwOperatingMode }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </ng-container>

      <!-- 2. Target Temperature -->
      <app-temperature-select
        data-at-dhw-temp-comfort-charging
        *ngIf="
          dhwActiveOperatingMode === comfortMode && dhwTemperatureComfortCharging$
            | async
            | ready as feature
        "
        title="{{
          '+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_TEMPERATURE_COMFORT_CHARGING' | translate
        }}"
        [rangeDefinition]="
          feature | constraints: featureCommands.setTemperature:featurePropertyKey.temperature
        "
        [value]="feature.properties?.value?.value"
        (valueChange)="onDhwTemperatureComfortChange($event)"
      ></app-temperature-select>

      <!-- 3.1. Sensor for Demand -->
      <!-- when DHW Operating Mode === Eco -->
      <ng-container
        *ngIf="dhwActiveOperatingMode === ecoMode && dhwEcoModeLeading$ | async | ready as feature"
      >
        <mat-form-field class="select-dhw-eco-mode-leading" mat-select-height-large>
          <mat-label
            matTooltip="{{
              '+INSTALLATIONS.INSTALLATION.WARM_WATER.HOT_WATER_TANK_MODE' | translate
            }}"
            >{{
              '+INSTALLATIONS.INSTALLATION.WARM_WATER.HOT_WATER_TANK_MODE' | translate
            }}</mat-label
          >
          <mat-select
            data-at-dhw-eco-mode-leading-select
            (selectionChange)="onDhwEcoModeLeadingChanged($event)"
            name="{{ '+INSTALLATIONS.INSTALLATION.WARM_WATER.HOT_WATER_TANK_MODE' | translate }}"
            [value]="feature | value2: featurePropertyKey.value"
            [disabled]="!(feature | executable: 'setValue')"
            [placeholder]="feature | value2: featurePropertyKey.value"
          >
            <mat-option
              gtm="onSelect"
              gtmAction="DHW Eco Mode Leading"
              gtmCategory="dhw"
              *ngFor="let mode of feature.commands?.setValue?.params?.value?.constraints?.enum"
              [value]="mode"
            >
              {{ mode | translateDhwEcoModeLeading }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <!-- 3.2. Sensor for Demand -->
      <!-- when DHW Operating Mode !== Eco & !== Comfort -->
      <ng-container
        *ngIf="
          (storageTankSensorTop$ | async | ready) ||
          (storageTankSensorMiddle$ | async | ready) ||
          (dhwEcoModeLeading$ | async | ready)
        "
      >
        <ng-container
          *ngIf="dhwActiveOperatingMode !== ecoMode && dhwActiveOperatingMode !== comfortMode"
        >
          <ng-container *ngIf="dhwEcoModeLeading$ | async | ready as feature">
            <mat-form-field class="select-dhw-eco-mode-leading" mat-select-height-large>
              <mat-label
                matTooltip="{{
                  '+INSTALLATIONS.INSTALLATION.WARM_WATER.HOT_WATER_TANK_MODE' | translate
                }}"
                >{{
                  '+INSTALLATIONS.INSTALLATION.WARM_WATER.HOT_WATER_TANK_MODE' | translate
                }}</mat-label
              >
              <mat-select
                data-at-dhw-eco-mode-leading-select
                fieldTextContentTooltip
                (selectionChange)="onDhwEcoModeLeadingChanged($event)"
                name="{{
                  '+INSTALLATIONS.INSTALLATION.WARM_WATER.HOT_WATER_TANK_MODE' | translate
                }}"
                value="{{ feature | value2: featurePropertyKey.value }}"
                [disabled]="!(feature | executable: 'setValue')"
                placeholder="{{ feature | value2: featurePropertyKey.value }} {{
                  feature | unit: 'value'
                }}"
              >
                <mat-option
                  gtm="onSelect"
                  gtmAction="DHW Eco Mode Leading"
                  gtmCategory="dhw"
                  fieldTextContentTooltip
                  *ngFor="let mode of feature.commands?.setValue?.params?.value?.constraints?.enum"
                  [value]="mode"
                >
                  {{ mode | translateDhwEcoModeLeading }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>

    <div class="section-row">
      <!-- 4. Minimum Comfort Temperature  -->
      <app-temperature-select
        *ngIf="dhwMinimumComfort$ | async | ready as feature"
        data-at-dhw-minimum-comfort
        [attr.data-feature]="feature.feature"
        id="select-dhw-minimum-comfort-temperature"
        title="{{ '+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_MINIMUM_COMFORT' | translate }}"
        [rangeDefinition]="feature | constraints: 'setTemperature':'temperature'"
        [value]="feature.properties?.value?.value"
        (valueChange)="onChangeMinimumComfortTemperature($event)"
      ></app-temperature-select>

      <!-- 5. DHW Target Temperature  -->
      <ng-container *ngIf="dhwTemperature$ | async | ready as feature">
        <!-- Workaround for mat-select canceling behaviour.
               When values change mat-select is force refreshed, and 2nd elements prevents flickering  -->
        <app-temperature-select
          data-at-dhw-target-temp1
          *ngIf="dhwTemperatureSelectVisible$ | async"
          id="select-dhw-set"
          title="{{ '+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_SET_TEMPERATURE' | translate }}"
          [rangeDefinition]="feature | constraints: 'setTargetTemperature':'temperature'"
          [value]="feature.properties?.value?.value"
          (valueChange)="onDhwTemperatureChange($event)"
        ></app-temperature-select>
        <app-temperature-select
          data-at-dhw-target-temp1
          *ngIf="!(dhwTemperatureSelectVisible$ | async)"
          title="{{ '+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_SET_TEMPERATURE' | translate }}"
          [rangeDefinition]="feature | constraints: 'setTargetTemperature':'temperature'"
          [value]="feature.properties?.value?.value"
          (valueChange)="onDhwTemperatureChange($event)"
        ></app-temperature-select>
      </ng-container>

      <!-- 6. DHW Target Temperature 2 -->
      <ng-container *ngIf="dhwTemperature2$ | async | ready as feature">
        <!-- Workaround for mat-select canceling behaviour.
        When values change mat-select is force refreshed, and 2nd elements prevents flickering  -->
        <app-temperature-select
          data-at-dhw-target-temp2
          *ngIf="dhwTemperatureSelectVisible$ | async"
          id="select-dhw-set2"
          title="{{ '+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_SET_TEMPERATURE_2' | translate }}"
          [rangeDefinition]="feature | constraints: 'setTargetTemperature':'temperature'"
          [value]="feature.properties?.value?.value"
          (valueChange)="onDhwTemperature2Change($event)"
        ></app-temperature-select>
        <app-temperature-select
          data-at-dhw-target-temp2
          *ngIf="!(dhwTemperatureSelectVisible$ | async)"
          title="{{ '+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_SET_TEMPERATURE_2' | translate }}"
          [rangeDefinition]="feature | constraints: 'setTargetTemperature':'temperature'"
          [value]="feature.properties?.value?.value"
          (valueChange)="onDhwTemperature2Change($event)"
        ></app-temperature-select>
      </ng-container>

      <!-- 7. Hysteresis -->
      <!-- setHysteresisSwitchOnValue -->
      <ng-container *ngIf="dhwHysteresis$ | async | ready as feature">
        <vi-item
          data-at-dhw-set
          *ngIf="feature.commands?.setHysteresisSwitchOnValue?.isExecutable"
          id="select-dhw-hysteresis-on"
          title="{{ '+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_HYSTERESIS_ON' | translate }}"
          [asDropdown]="true"
          [valueSpecification]="feature | constraints: 'setHysteresisSwitchOnValue':'hysteresis'"
          [value]="feature.properties?.switchOnValue?.value"
          [unit]="feature.properties?.switchOnValue?.unit"
          (valueChange)="onDhwHysteresisChange($event, featureCommands.setHysteresisSwitchOnValue)"
        ></vi-item>
        <!-- setHysteresisSwitchOffValue -->
        <vi-item
          data-at-dhw-set
          *ngIf="feature.commands?.setHysteresisSwitchOffValue?.isExecutable"
          id="select-dhw-hysteresis-off"
          title="{{ '+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_HYSTERESIS_OFF' | translate }}"
          [asDropdown]="true"
          [valueSpecification]="feature | constraints: 'setHysteresisSwitchOffValue':'hysteresis'"
          [value]="feature.properties?.switchOffValue?.value"
          [unit]="feature.properties?.switchOffValue?.unit"
          (valueChange)="onDhwHysteresisChange($event, featureCommands.setHysteresisSwitchOffValue)"
        ></vi-item>
      </ng-container>
    </div>
  </div>

  <app-feature-list-container
    title="{{ '+INSTALLATIONS.INSTALLATION.WARM_WATER.TITLE_SENSOR_READINGS' | translate }}"
  >
    <div class="feature-grid-container" viFeatureGrid viBorderBottom>
      <!-- 2.1 Storage Tank Sensor -->
      <app-feature-list-item
        data-at-dhw-storage-temp
        *ngIf="bufferSensorTemperature$ | async | ready | sensorStatusConnected as feature"
        [label]="'+INSTALLATIONS.INSTALLATION.WARM_WATER.STORAGE_TEMPERATURE' | translate"
        value="{{ feature | value2: featurePropertyKey.value }} {{ feature | unit: 'value' }}"
        [attr.data-feature]="feature.feature"
      >
      </app-feature-list-item>
      <!-- 2.2 Storage Tank Sensor Top -->
      <app-feature-list-item
        data-at-dhw-storage-temp-top
        *ngIf="bufferSensorTemperatureTop$ | async | ready | sensorStatusConnected as feature"
        [label]="'+INSTALLATIONS.INSTALLATION.WARM_WATER.STORAGE_TEMPERATURE_TOP' | translate"
        value="{{ feature | value2: featurePropertyKey.value }} {{ feature | unit: 'value' }}"
        [attr.data-feature]="feature.feature"
      >
      </app-feature-list-item>
      <!-- 2.3 Storage Tank Sensor Middle -->
      <app-feature-list-item
        data-at-dhw-storage-temp-middle
        *ngIf="bufferSensorTemperatureMiddle$ | async | ready | sensorStatusConnected as feature"
        [label]="'+INSTALLATIONS.INSTALLATION.WARM_WATER.STORAGE_TEMPERATURE_MIDDLE' | translate"
        value="{{ feature | value2: featurePropertyKey.value }} {{ feature | unit: 'value' }}"
        [attr.data-feature]="feature.feature"
      >
      </app-feature-list-item>
      <!-- 2.4 Storage Tank Sensor Mid Bottom -->
      <app-feature-list-item
        data-at-dhw-storage-temp-mid-bottom
        *ngIf="bufferSensorTemperatureMidBottom$ | async | ready | sensorStatusConnected as feature"
        [label]="
          '+INSTALLATIONS.INSTALLATION.WARM_WATER.STORAGE_TEMPERATURE_MID_BOTTOM' | translate
        "
        value="{{ feature | value2: featurePropertyKey.value }} {{ feature | unit: 'value' }}"
        [attr.data-feature]="feature.feature"
      >
      </app-feature-list-item>
      <!-- 2.5 Storage Tank Sensor Bottom -->
      <app-feature-list-item
        data-at-dhw-storage-temp-bottom
        *ngIf="bufferSensorTemperatureBottom$ | async | ready | sensorStatusConnected as feature"
        [label]="'+INSTALLATIONS.INSTALLATION.WARM_WATER.STORAGE_TEMPERATURE_BOTTOM' | translate"
        value="{{ feature | value2: featurePropertyKey.value }} {{ feature | unit: 'value' }}"
        [attr.data-feature]="feature.feature"
      >
      </app-feature-list-item>

      <ng-container
        *ngIf="dhwActiveOperatingMode !== ecoMode && dhwActiveOperatingMode !== comfortMode"
      >
        <ng-container *ngIf="dhwEcoModeLeading$ | async | ready as feature">
          <!-- 3. Eco Mode Leading Sensor -->

          <app-feature-list-item
            data-at-dhw-eco-mode-leading
            [label]="'+INSTALLATIONS.INSTALLATION.WARM_WATER.ECO_MODE_LEADING_SENSOR' | translate"
            value="{{ feature | value2: featurePropertyKey.value }} {{ feature | unit: 'value' }}"
            [attr.data-feature]="feature.feature"
          >
          </app-feature-list-item>
        </ng-container>
      </ng-container>

      <!-- 4. Rust Surveilance Current -->
      <app-feature-list-item
        [attr.data-at-dhw-rust-surveillance-current-unit]="feature | unit: 'value'"
        [attr.data-at-dhw-rust-surveillance-current-value]="
          feature | value2: featurePropertyKey.value
        "
        *ngIf="dhwRustSurveillanceAnode$ | async | ready as feature"
        [attr.data-feature]="feature.feature"
        [error]="feature | error"
        [label]="'+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_RUST_SURVEILLANCE_ANODE' | translate"
        value="{{ feature | value2: featurePropertyKey.value }} {{
          feature | unit: featurePropertyKey.value
        }}"
      ></app-feature-list-item>

      <!-- 5 Actuator for DHW-Preparation -->
      <app-feature-list-item
        data-at-actuator-for-dhw-preparation
        *ngIf="actuatorForDhwPreparation$ | async | ready as feature"
        [label]="'+INSTALLATIONS.INSTALLATION.WARM_WATER.ACTUATOR_FOR_DHW_PREPARATION' | translate"
        value="{{ feature | value2: featurePropertyKey.value | translateState }}"
        [attr.data-feature]="feature.feature"
      >
      </app-feature-list-item>
    </div>
  </app-feature-list-container>

  <div
    class="section-wrapper"
    *ngIf="
      ((devicesStore.isEcotronicDevice$ | async) && dhwScheduleMode$ | async | ready) ||
      (dhwSchedule$ | async | ready) ||
      (dhwOneTimeCharge$ | async | ready) ||
      (offPeakSignalActive$ | async | ready)
    "
  >
    <h3 class="section-heading">
      {{ '+INSTALLATIONS.INSTALLATION.WARM_WATER.TITLE_TIME_PROGRAM' | translate }}
    </h3>
    <ng-container *ngIf="offPeakSignalActive$ | async | ready as feature">
      <mat-slide-toggle
        #enableSwitch
        data-at-off-peak-signal-toggle
        gtm="onToggle"
        gtmCategory="Manage features"
        gtmAction="Switch offpeak on off"
        [disabled]="!(feature | executable: featureCommands.activate)"
        [checked]="feature.properties?.active?.value"
        (click)="
          onOffPeakSignalConfigurationChange(enableSwitch, !feature.properties?.active?.value)
        "
        >{{ '+INSTALLATIONS.INSTALLATION.OFF_PEAK_SIGNAL.DESCRIPTION' | translate }}
      </mat-slide-toggle>
    </ng-container>
    <!-- DHW Schedule Mode -->
    <!-- show only for ecotronic device -->
    <ng-container
      *ngIf="
        (devicesStore.isEcotronicDevice$ | async) && dhwScheduleMode$ | async | ready as feature
      "
    >
      <mat-form-field class="select-dhw-schedule-mode" mat-select-height-large>
        <mat-label
          matTooltip="{{
            '+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_SELECT_SCHEDULE_MODE' | translate
          }}"
          >{{
            '+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_SELECT_SCHEDULE_MODE' | translate
          }}</mat-label
        >
        <mat-select
          data-at-dhw-schedule-mode-select
          fieldTextContentTooltip
          (selectionChange)="onDhwScheduleModeChanged($event)"
          name="{{ '+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_SELECT_SCHEDULE_MODE' | translate }}"
          [value]="dhwActiveScheduleMode"
          [placeholder]="dhwActiveScheduleMode | translateDhwScheduleMode"
          [disabled]="!(feature | executable: featureCommands.setMode)"
        >
          <mat-option
            gtm="onSelect"
            gtmAction="DHW Schedule Mode"
            gtmCategory="dhw"
            fieldTextContentTooltip
            *ngFor="let mode of feature.commands?.setMode?.params?.mode?.constraints?.enum"
            [value]="mode"
          >
            {{ mode | translateDhwScheduleMode }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>

    <ng-container *ngIf="(isMultiFamily$ | async | ready)?.properties?.active?.value !== true">
      <ng-container *ngIf="tabs$ | async as featureTabs">
        <nav data-at-tabs mat-tab-nav-bar [tabPanel]="tabPanel" *ngIf="featureTabs.showTabs">
          <ng-container *ngFor="let f of featureTabs.list">
            <a
              data-at-tab
              mat-tab-link
              *ngIf="f | ready as feature"
              id="tab-{{ feature.feature }}"
              [class.active]="activeTab === feature.feature"
              [active]="activeTab === feature.feature"
              gtm="onSelect"
              gtmAction="Tab of DHW"
              gtmCategory="switchingTimes"
              (click)="onTabChange(feature)"
            >
              {{ feature.feature | translateScheduleTab }}
            </a>
          </ng-container>
        </nav>
        <mat-tab-nav-panel #tabPanel>
          <router-outlet></router-outlet>
        </mat-tab-nav-panel>
        <app-timemanager
          *ngIf="initTabs(featureTabs.list)"
          [class.disabled]="
            (devicesStore.isEcotronicDevice$ | async) &&
            activeTab === dhwScheduleFeature &&
            dhwActiveScheduleMode === dhwScheduleModeType.Automatic
          "
          (scheduleChange)="onScheduleChange($event, featureTabs.list)"
        >
        </app-timemanager>
        <div
          *ngIf="editMultipleDays"
          class="programs-container flex flex-row justify-between items-center"
        >
          <button
            mat-stroked-button
            color="primary"
            gtm="onOpen"
            gtmAction="Multiple days selection dialog"
            gtmCategory="waterSchedule"
            id="edit-multiple-dhw-btn"
            [disabled]="
              (devicesStore.isEcotronicDevice$ | async) &&
              activeTab === dhwScheduleFeature &&
              dhwActiveScheduleMode === dhwScheduleModeType.Automatic
            "
            data-at-edit-multiple
            (click)="onEditMultipleDays()"
          >
            {{ '+SCHEDULES.BUTTON.EDIT_MULTIPLE_DAYS' | translate }}
          </button>
          <div data-at-programs class="programs flex flex-row flex-wrap">
            <vi-program-item
              *ngFor="let program of programs$ | async"
              program="{{ program.css }} {{ 'dhw' }}"
              [hasTemperature]="false"
            >
              <vi-text name class="flex-1">
                {{ program?.name | translateOperatingProgram }}
              </vi-text>
            </vi-program-item>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <div *ngIf="dhwOneTimeCharge$ | async | ready as feature" class="slide-toggle-container">
      <mat-slide-toggle
        [attr.data-at-feature-one-time-charge]="feature.properties?.active?.value"
        #matSlideDhwOneTimeCharge
        class="slide-toggle"
        [class.disabled]="!(isDhwOneTimeChargeEnabled$ | async)"
        [disabled]="!(isDhwOneTimeChargeEnabled$ | async)"
        [checked]="feature.properties?.active?.value"
        (change)="onDhwOneTimeChargeChange(!feature.properties?.active?.value)"
      >
        {{ '+SCHEDULES.TOGGLE.DHW_CHARGE' | translate }}
      </mat-slide-toggle>
    </div>
  </div>
</div>
